import { getActiveNetwork } from '@/lib/network/getActiveNetwork';
import { E_Network } from '@/ts/enums/E_Network';

export const C_NETWORK_ID_MAP: Record<E_Network, number> = {
  [E_Network.BASE]: 8453,
  [E_Network.BASE_SEPOLIA]: 84532,
  [E_Network.SEPOLIA]: 11155111
};

export const C_BASE_NETWORK_ID = C_NETWORK_ID_MAP[E_Network.BASE];
export const C_BASE_SEPOLIA_NETWORK_ID =
  C_NETWORK_ID_MAP[E_Network.BASE_SEPOLIA];
export const C_SEPOLIA_ETH_NETWORK_ID = C_NETWORK_ID_MAP[E_Network.SEPOLIA];

export const C_ACTIVE_NETWORK = getActiveNetwork();
export const C_ACTIVE_NETWORK_ID = C_NETWORK_ID_MAP[C_ACTIVE_NETWORK];

export const C_SUPPORTED_NETWORK_IDS = [C_ACTIVE_NETWORK_ID] as const;
